///<reference path='../../typings/index.d.ts' />

module agi.expressions.card.utils{
    import MovieClip = PIXI.extras.MovieClip;

    export class SpriteUtils{

        /**
         * @deprecated You should use SplitSpriteContainer instead!
         * @param spritePrefix 
         * @param spriteNumber 
         * @param container 
         * @param parentContainer 
         */
        public static spriteBuilder(spritePrefix:string,spriteNumber,container:PIXI.Container,parentContainer:PIXI.Container){
            for(var i=1;i<=spriteNumber;i++){
                var aSprite:PIXI.Sprite=PIXI.Sprite.fromFrame(spritePrefix+i+".png");                
                container.addChild(aSprite);
            }
            container.cacheAsBitmap=true; 
            parentContainer.addChild(container);
        }

        public static movieClipBuilder(spritePrefix:string,numFrames:number,speed:number,zeros:number,startAt:number):PIXI.extras.MovieClip{
            var textures:Array<PIXI.Texture> = [];
            var frameId:string;
            for(var i:number=startAt; i<startAt + numFrames; i++){
                frameId = spritePrefix + this.padWithZeros(zeros, i) + '.png';
                textures.push(PIXI.Texture.fromFrame(frameId));
            }
            var mc = new MovieClip(textures);
            mc.animationSpeed = speed;

            return mc;
        }

        public static padWithZeros(width:number, val:number):string{
            var paddedNumber:string = val.toString();
            var padWidth:number = width - paddedNumber.length;
            for(var i:number=0; i<padWidth; i++)
                paddedNumber = '0'+paddedNumber;
            return paddedNumber;
        }
    }
}
